import {
  Component,
  HostBinding,
  Input,
  OnChanges,
  Output,
  EventEmitter,
  inject,
  SimpleChanges
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { UmssButtonComponent } from '../button/button.component';
import { OverlayZIndexService } from '../../services/overlay-z-index.service';

@Component({
  selector: 'umss-alert-dialog',
  standalone: true,
  imports: [CommonModule, UmssButtonComponent],
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class UmssAlertDialogComponent implements OnChanges {
  @HostBinding('style.display') display = 'contents';

  private readonly zIndexService = inject(OverlayZIndexService);
  overlayZIndex = this.zIndexService.base;

  ngOnChanges(changes: SimpleChanges): void {
    const openChange = changes['open'];
    if (openChange?.currentValue === true && !openChange.previousValue) {
      this.overlayZIndex = this.zIndexService.next();
    }
  }

  /** Content props */
  @Input() title: string = 'Alert';
  @Input() message: string = 'Are you sure you want to continue?';
  @Input() primaryButtonLabel: string = 'Confirm';
  @Input() secondaryButtonLabel: string = 'Cancel';

  /** Variant props */
  @Input() type: 'Mobile' | 'Desktop' = 'Mobile';
  @Input() variant: 'Info' | 'Warning' | 'Error' | 'Success' = 'Info';
  @Input() primaryButtonVariant:
    | 'Primary'
    | 'Secondary'
    | 'Destructive'
    | 'Ghost'
    | 'Outline' = 'Primary';
  @Input() secondaryButtonVariant:
    | 'Primary'
    | 'Secondary'
    | 'Destructive'
    | 'Ghost'
    | 'Outline' = 'Outline';

  /** State props */
  @Input() open: boolean = false;
  @Input() showSecondaryButton: boolean = true;
  @Input() loading: boolean = false;

  /** Button icon props */
  @Input() primaryButtonLeftIconName?: string;
  @Input() primaryButtonRightIconName?: string;
  @Input() secondaryButtonLeftIconName?: string;
  @Input() secondaryButtonRightIconName?: string;

  /** Events */
  @Output() onPrimaryClick = new EventEmitter<void>();
  @Output() onSecondaryClick = new EventEmitter<void>();
  @Output() onClose = new EventEmitter<void>();

  /** Event handlers */
  handlePrimaryClick() {
    this.onPrimaryClick.emit();
  }

  handleSecondaryClick() {
    this.onSecondaryClick.emit();
  }
}
